module.exports = __webpack_public_path__ + "img/bandrec-hh-logo-short.687e1467.svg";